export const RECORDING_VIDEO_PLAYER_READY = "recording-video-player-ready";
export const RECORDING_VIDEO_START_PLAYING = "recording-video-start-playing";
export const RECORDING_SHOW_VIDEO = "recording-show-video";
export const MINI_PLAYER_OPENED_EVENT = "mini-player-opened";

export type RecordingVideoPlayerReadyEvent = CustomEvent<{
	meetingRecordingId?: string;
	updateVideoState: (playing: boolean, currentTime: number) => void;
	videoRef: React.RefObject<HTMLVideoElement>;
	containerRef: React.RefObject<HTMLDivElement>;
}>;
export type RecordingVideoStartPlayingEvent = CustomEvent<{
	meetingRecordingId?: string;
}>;
export type RecordingShowVideoEvent = CustomEvent<{
	playing: boolean;
	currentTime: number;
}>;

declare global {
	interface WindowEventMap {
		[RECORDING_VIDEO_PLAYER_READY]: RecordingVideoPlayerReadyEvent;
		[RECORDING_VIDEO_START_PLAYING]: RecordingVideoStartPlayingEvent;
		[MINI_PLAYER_OPENED_EVENT]: CustomEvent<null>;
	}
	interface HTMLElementEventMap {
		[RECORDING_SHOW_VIDEO]: RecordingShowVideoEvent;
	}
}
